import React, {useEffect, useRef, useState} from 'react';
import useClientPeselReservedPageLogic from './hooks/useClientPeselReservedPageLogic'
import {IClientPeselReservedVerticalContentStepperProps} from './ClientPeselReservedPageProps'
import {getAppLinkBasedOnOS} from '../../common/helpers/helpers'

import './ClientPeselReservedPageStyles.scss'
import PageScreen from "../../components/organisms/Page/PageScreen";
import Paragraph from "../../components/atoms/Paragraph/Paragraph";
import AppButton from "../../components/atoms/AppButton/AppButton";
import {UI_BUTTON_TYPE} from "../../components/atoms/AppButton/AppButtonProps";
import {AppList} from "../../components/atoms/AppList/AppList";
import {AppListItem} from "../../components/atoms/AppListItem/AppListItem";
import LoanOfferSummaryPanel from "../../components/organisms/LoanOfferSummaryPanel/LoanOfferSummaryPanel";
import {APP_COLOR} from "../../components/atoms/AtomsGlobalProps";


const ClientPeselReservedVerticalContentStepper = (props: IClientPeselReservedVerticalContentStepperProps) => {

   const { textContent } = props

    const firstStep = `
          Zaloguj się do aplikacji 
          <b>
            <a href="${getAppLinkBasedOnOS()}" target="_blank" rel="noreferrer">
              &nbsp;mObywatel&nbsp;
            </a>
          </b>
          lub na stronę
          <b>
            <a href="https://mobywatel.gov.pl" target="_blank" rel="noreferrer">
              &nbsp;mobywatel.gov.pl&nbsp;
            </a>
          </b>
          i cofnij tymczasowo <b>zastrzeżenie PESEL.</b>
        `;
   return (

       <AppList>
           <AppListItem html={firstStep} className={"client-pesel-reserved-step-margin"}/>
           <AppListItem html={textContent('clientPeselReservedPage.stepperStage2')}/>
       </AppList>
   )
 }


const ClientPeselReservedPage = () => {

   const {
      handleOnButtonCheckClick,
      isButtonBlocked,
      isButtonLoading,
      currentClientPeselReservedErrorText,
      textContent
   } = useClientPeselReservedPageLogic()

    const [errorMsg, setErrorMsg] = useState<string | null>(()=> currentClientPeselReservedErrorText)
    useEffect(() => {
        setErrorMsg(currentClientPeselReservedErrorText)
    }, [currentClientPeselReservedErrorText]);

   return (
      <PageScreen
          panel={<LoanOfferSummaryPanel readOnly={true} loanVariant='selectedOffer' />}
          title={{title:textContent('clientPeselReservedPage.header'), line: true}}>
         <div className='page-gap'>
            <Paragraph html={textContent('clientPeselReservedPage.description')} />
            <ClientPeselReservedVerticalContentStepper textContent={textContent} />
             <div style={{textAlign: "center"}} >

                <AppButton
                   isLoading={isButtonLoading}
                   disabled={isButtonBlocked}
                   uiButtonType={UI_BUTTON_TYPE.PRIMARY}
                   className='client-pesel-reserved-page-submit-button'
                   onClick={() => {
                       setErrorMsg(null)
                       handleOnButtonCheckClick()}}
                >Sprawdź</AppButton>
            {
                       errorMsg ?
               <Paragraph align={"center"} color={APP_COLOR.ERROR} bold={true} className={"client-pesel-reserved-page-error-message-text-margin-before"}>{errorMsg}</Paragraph> :
                   <p className='client-pesel-reserved-page-error-message-text' />
            }
             </div>
         </div>
      </PageScreen>
   )
}

export default ClientPeselReservedPage